import React from 'react';
import {NavLink} from 'react-router-dom';

export default function VerificationLayout({children}) {
  const count = localStorage.getItem('pendingCount') || 0;
  return (
    <>
      <div className="mt-6 md:mt-[27px] mb-4">
        <div className="mt-4 rounded-md bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
          <NavLink
            end
            to={'/verifications'}
            className={({isActive}) =>
              `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                isActive
                  ? 'text-black bg-white shadow-tabs'
                  : 'text-grey-500 bg-transparent'
              }`
            }
          >
            All Verifications
          </NavLink>
          <NavLink
            to={`/verifications/pending`}
            className={({isActive}) =>
              `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                isActive
                  ? 'text-black bg-white shadow-tabs'
                  : 'text-grey-500 bg-transparent'
              }`
            }
          >
            My Pending Verifications
            <span className="ml-2">({count})</span>
          </NavLink>
        </div>
      </div>

      {/*{renderFlowCards({cards: ANALYSIS_DATA?.cards, isLoading})}*/}

      {children}
    </>
  );
}
